module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('h1', {
    staticClass: "titlepage"
  }, [_c('span', {
    staticClass: "lighter"
  }, [_vm._v("A LIFE WORTH LIVING")]), _c('br'), _vm._v("THE 9 ESSENTIALS")])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big2"
  }, [_c('strong', [_vm._v("BARRIE SANFORD GREIFF, M.D.")])]), _c('br'), _vm._v("Previously published under the title "), _c('em', [_vm._v("Legacy")])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8471608","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062046253_epub_tp_r1.vue
// module id = 60
// module chunks = 0